var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_44_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_45_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st0",
    d: "M150,31.1c38.7,0,43.3,0.1,58.6,0.8c14.1,0.6,21.8,3,26.9,5c6.8,2.6,11.6,5.8,16.7,10.8 c5.1,5.1,8.2,9.9,10.8,16.7c2,5.1,4.3,12.8,5,26.9c0.7,15.3,0.8,19.9,0.8,58.6c0,38.7-0.2,43.3-0.8,58.6c-0.6,14.1-3,21.8-5,26.9 c-2.6,6.8-5.8,11.6-10.8,16.7c-5.1,5.1-9.9,8.2-16.7,10.8c-5.1,2-12.8,4.4-26.9,5c-15.3,0.7-19.9,0.8-58.6,0.8 c-38.7,0-43.3-0.1-58.6-0.8c-14.1-0.6-21.8-3-26.9-5c-6.8-2.6-11.6-5.8-16.7-10.8c-5.1-5.1-8.2-9.9-10.8-16.7 c-2-5.1-4.3-12.8-5-26.9c-0.7-15.3-0.8-19.9-0.8-58.6c0-38.7,0.1-43.3,0.8-58.6c0.6-14.1,3-21.8,5-26.9 c2.6-6.8,5.8-11.6,10.8-16.7c5.1-5.1,9.9-8.2,16.7-10.8c5.1-2,12.8-4.4,26.9-5C106.7,31.3,111.3,31.1,150,31.1 M150,5 c-39.4,0-44.3,0.2-59.8,0.9C74.8,6.6,64.2,9,55,12.6c-9.5,3.7-17.6,8.7-25.7,16.7c-8.1,8.1-13,16.1-16.7,25.7 c-3.6,9.2-6,19.8-6.7,35.2C5.2,105.7,5,110.6,5,150c0,39.4,0.2,44.3,0.9,59.8c0.7,15.4,3.2,26,6.7,35.2 c3.7,9.5,8.7,17.6,16.7,25.7c8.1,8.1,16.1,13,25.7,16.7c9.2,3.6,19.8,6,35.2,6.7c15.5,0.7,20.4,0.9,59.8,0.9 c39.4,0,44.3-0.2,59.8-0.9c15.4-0.7,26-3.2,35.2-6.7c9.5-3.7,17.6-8.7,25.7-16.7c8.1-8.1,13-16.1,16.7-25.7 c3.6-9.2,6-19.8,6.7-35.2c0.7-15.5,0.9-20.4,0.9-59.8c0-39.4-0.2-44.3-0.9-59.8c-0.7-15.4-3.2-26-6.7-35.2 c-3.7-9.5-8.7-17.6-16.7-25.7c-8.1-8.1-16.1-13-25.7-16.7c-9.2-3.6-19.8-6-35.2-6.7C194.3,5.2,189.4,5,150,5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st0",
    d: "M150,75.5c-41.1,0-74.5,33.3-74.5,74.5s33.3,74.5,74.5,74.5c41.1,0,74.5-33.3,74.5-74.5 S191.1,75.5,150,75.5 M150,198.3c-26.7,0-48.3-21.6-48.3-48.3c0-26.7,21.6-48.3,48.3-48.3c26.7,0,48.3,21.6,48.3,48.3 C198.3,176.7,176.7,198.3,150,198.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st0",
    d: "M244.8,72.6c0,9.6-7.8,17.4-17.4,17.4c-9.6,0-17.4-7.8-17.4-17.4s7.8-17.4,17.4-17.4 C237,55.2,244.8,63,244.8,72.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c47f204e2e098bf6b293a93fec5197c8.svg";
export { ForwardRef as ReactComponent };